export const THEMES = {
  stamp: {
    key: "stamp",
    name: "K8 Stamp",
    vars: {
      "--bg-primary": "#0A0A0E",
      "--bg-secondary": "#13131A",
      "--bg-card": "#1A1A24",
      "--border": "rgba(255,255,255,0.12)",
      "--text-main": "#F8FAFC",
      "--text-muted": "#94A3B8",
      "--accent": "#FF9500",
      "--accent-2": "#007AFF",
      "--btn-bg": "#FF9500",
      "--btn-hover": "#E08200",
      "--btn-text": "#000000",
      "--accent-gradient":
        "linear-gradient(135deg,#FF3B30 0%,#FF9500 25%,#FFCC00 50%,#34C759 75%,#007AFF 100%)",
      "--heading-font": "'Outfit', sans-serif",
      "--body-font": "'Plus Jakarta Sans', sans-serif",
    },
  },
  sports: {
    key: "sports",
    name: "K8 Sports",
    vars: {
      "--bg-primary": "#0D0D11",
      "--bg-secondary": "#15151C",
      "--bg-card": "#1E1E28",
      "--border": "rgba(212,175,55,0.22)",
      "--text-main": "#F3F4F6",
      "--text-muted": "#A1A1AA",
      "--accent": "#D4AF37",
      "--accent-2": "#F5E48B",
      "--btn-bg": "#D4AF37",
      "--btn-hover": "#C59E27",
      "--btn-text": "#0D0D11",
      "--accent-gradient":
        "linear-gradient(135deg,#F5E48B 0%,#D4AF37 50%,#997A15 100%)",
      "--heading-font": "'Barlow Condensed', 'Outfit', sans-serif",
      "--body-font": "'Plus Jakarta Sans', sans-serif",
    },
  },
  pagode: {
    key: "pagode",
    name: "Pagode das Cinco Pontas",
    vars: {
      "--bg-primary": "#1A1206",
      "--bg-secondary": "#241A0C",
      "--bg-card": "#2E2211",
      "--border": "rgba(245,179,1,0.28)",
      "--text-main": "#FFF7E8",
      "--text-muted": "#E8C9A0",
      "--accent": "#F5B301",
      "--accent-2": "#FF4D6D",
      "--btn-bg": "#F5B301",
      "--btn-hover": "#E0A200",
      "--btn-text": "#1A1206",
      "--accent-gradient":
        "linear-gradient(135deg,#FFC300 0%,#FF5D8F 50%,#2BD9A8 100%)",
      "--heading-font": "'Outfit', sans-serif",
      "--body-font": "'Plus Jakarta Sans', sans-serif",
    },
  },
};

export function brandFromPath(pathname) {
  if (pathname.startsWith("/k8-sports")) return "sports";
  if (pathname.startsWith("/pagode")) return "pagode";
  return "stamp";
}
